import React from 'react';
import PropTypes from 'prop-types';
import { Button, InputNumber, Col, Row, DatePicker, Spin, Collapse, Popconfirm } from 'antd';
import { Field } from 'redux-form';
import { TextField, TextAreaField, SelectField } from 'redux-form-antd';

import './index.css';
import { Link } from 'react-router-dom';
import AppTemplate from '../../templates/AppTemplate';
import RangePicker from '../../molecules/RangePicker';
import TargetingTab from '../../../containers/targeting/TargetingTab';
import ForecastResults from '../../../containers/forecast/ForecastResults';
import InlineMessage from '../../atoms/InlineMessage';
import ForecastAdjustments from '../../../containers/forecast/ForecastAdjustments';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

const { Panel } = Collapse;

const Forecast = ({
  changeActiveKey,
  activeMenus,
  history,
  creating,
  saving,
  calculating,
  handleSaveRun,
  handleCreateRevision,
  handleSave,
  hasLocationOrChain,
  resultsData,
  forecast,
  warnDirty,
  handleRevisionSelect,
  submitting,
  loading,
  revisionList,
}) => (
  <AppTemplate>
    {/* Weird workaround for https://github.com/zhDmitry/redux-form-antd/issues/30 */}
    <DatePicker style={{ display: 'none' }} />
    <InputNumber style={{ display: 'none' }} />

    <Row type="flex" justify="space-between">
      <Col span={20}>
        <h1>{forecast.name}</h1>
      </Col>
    </Row>

    {!loading && !hasLocationOrChain && (
      <div>
        <InlineMessage
          type="warning"
          message={
            <span>
              Before you're able to save, you must add <strong>location</strong> or{' '}
              <strong>chain</strong> targeting to this revision.
            </span>
          }
        />
      </div>
    )}

    <form className="forecastForm">
      <Spin spinning={loading}>
        <Row>
          <Col span={8}>
            <Field {...formItemLayout} label="Name" name="name" component={TextField} />
            <RangePicker />

            {revisionList.length > 1 && (
              <Field
                {...formItemLayout}
                label="Revision"
                name="revision"
                onSelect={handleRevisionSelect}
                component={SelectField}
                options={revisionList}
              />
            )}
          </Col>
          <Col span={16}>
            <Field {...formItemLayout} label="Notes" name="notes" component={TextAreaField} />
          </Col>
        </Row>
      </Spin>
      <Row>
        <Col offset={3}>
          {warnDirty && (
            <Popconfirm
              placement="topRight"
              title="Your forecast has unsaved changes, If you leave without saving you will lose these changes."
              onConfirm={() => history.push('/forecasts')}
              okText="Don't save changes"
              cancelText="Wait, let me save first"
            >
              <a href="#cancel">Cancel</a>
            </Popconfirm>
          )}

          {!warnDirty && <Link to="/forecasts">Cancel</Link>}

          <Button
            style={{ marginLeft: 10 }}
            type="primary"
            onClick={handleCreateRevision}
            loading={creating}
            disabled={!hasLocationOrChain}
          >
            Create New Revision
          </Button>

          <Button
            style={{ marginLeft: 10 }}
            type="primary"
            onClick={handleSave}
            loading={saving}
            disabled={!hasLocationOrChain}
          >
            Save
          </Button>

          {forecast.status === 0 && (
            <Button
              id="save-and-run"
              style={{ marginLeft: 10 }}
              type="primary"
              onClick={handleSaveRun}
              loading={calculating}
              disabled={!hasLocationOrChain}
            >
              Save & Run Forecast
            </Button>
          )}
        </Col>
      </Row>
    </form>
    <div style={{ marginTop: 20 }} />
    {!loading && (
      <Collapse bordered={false} onChange={changeActiveKey} activeKey={activeMenus}>
        <Panel forceRender header="Results" key="results">
          <ForecastResults calculating={calculating} />
        </Panel>
        <Panel forceRender header="Make Adjustments" key="adjustments">
          <ForecastAdjustments />
        </Panel>
        <Panel forceRender header="Targeting" key="targeting">
          <TargetingTab allowedTabs={['App', 'Chain', 'State', 'Location', 'AudienceForecast']} />
        </Panel>
      </Collapse>
    )}
  </AppTemplate>
);

Forecast.defaultProps = {
  submitting: false,
  hasLocationOrChain: false,
};

Forecast.propTypes = {
  hasLocationOrChain: PropTypes.bool,
  submitting: PropTypes.bool,
};

export default Forecast;
